import {
  Component,
  EventEmitter,
  Output,
  Input,
  ViewChild,
} from '@angular/core';
import {
  PopoverController,
  ToastController,
  ActionSheetController,
  AlertController,
} from 'ionic-angular';
import { NavController } from 'ionic-angular';
import { SocialSharingProvider } from '../../providers/social-sharing/social-sharing';
import { CrudApiProvider } from '../../providers/crud-api/crud-api';
import { ToolsProvider } from '../../providers/tools/tools';
import { UserProvider } from '../../providers/user/user';
import { AdsProvider } from '../../providers/ads/ads';
import * as _ from 'lodash';
import * as moment from 'moment';
import * as debug from 'debug';
import { EnvVariables } from '../../environments/environment';
import { ConfigProvider } from '../../providers/config/config';

declare let CmKit: any;

@Component({
  selector: 'post-loader',
  templateUrl: 'post-loader.html',
})
export class PostLoaderComponent {
  log = debug('app:PostLoaderComponent');

  allowedPosts = [
    'VIDEO',
    'PHOTO',
    'MESSAGE',
    'LINK',
    'AD',
    'JOB',
    'REVIEW',
    'ARTICLE',
    'AD_SPEC',
    'CUSTOM_COMPONENT',
  ];

  @ViewChild('tagPending')
  tagPending;
  @ViewChild('tagRejected')
  tagRejected;

  @Input() post;
  @Input() isPinnedPost = false;
  @Input() checkHiddenContent = false;
  postInfo;
  hidePost = false;
  @Input()
  noTruncate: string;
  @Input()
  temporarilyBlockOpen: any = false;
  @Input()
  blockOpenPost: any = false;
  @Input()
  fullPost = false;
  @Input()
  searchedPost = false;
  @Input()
  inFeed = false;
  @Input()
  canNavToSourceProfile: any = true;
  @Input()
  showCustomTagBanner = false;
  @Input()
  isBoostable = false;

  @Output()
  scrollToEmitter = new EventEmitter();
  @Output() onHidePost = new EventEmitter();
  @Output() onBlockUser = new EventEmitter();

  text: string;

  subs = [];

  postEngagementMessage = '';
  actionsRegistered = {};
  adTakeover;
  confirmBoostSpend = false;
  boostCost: number = 100;
  remaining: number = -1;
  karmaMile: number = 0;

  tagViolatedMessages = [
    {
      title: 'Insufficient Karma Miles',
      description: 'You may not have sufficient karma miles to create a tag',
    },
    {
      title: 'Inappropriate Language',
      description: 'Tag contains offensive or inappropriate language',
    },
    {
      title: 'Too Many Submissions',
      description: 'There are too many submissions at the time of submission',
    },
    {
      title: 'Similar Tag Already in Use',
      description:
        'A user has previously submitted a tag that is too similar to your submission',
    },
  ];
  customTagCost = 100;

  Math;

  constructor(
    public popoverCtrl: PopoverController,
    public toastCtrl: ToastController,
    public actionSheetCtrl: ActionSheetController,
    public navCtrl: NavController,
    public crudApi: CrudApiProvider,
    public tools: ToolsProvider,
    public user: UserProvider,
    public ads: AdsProvider,
    public alertCtrl: AlertController,
    public env: EnvVariables,
    public config: ConfigProvider
  ) {
    this.subs.push(
      this.user.on('hideShowContent', () => {
        if (
          this.checkHiddenContent &&
          !this.user.userShouldSeeContent(this.post)
        ) {
          this.hidePost = true;
        }
      })
    );
  }

  ngOnInit() {
    if (
      this.post.user &&
      this.user &&
      this.user.info &&
      this.post.user._id === this.user.info._id &&
      (_.get(this.post, 'states.hasCustomTag.status') === 'pending' ||
        _.get(this.post, 'states.hasCustomTag.status') === 'rejected')
    ) {
      this.showCustomTagBanner = true;
    }

    if (
      this.post.user &&
      this.user &&
      this.user.info &&
      this.post.user._id === this.user.info._id &&
      !this.post.states.wasBoosted
    ) {
      this.isBoostable = true;
    }

    this.karmaMile = _.get(this.user.info, 'stats.events.karmaMile') || 0;
    this.boostCost = Math.abs(this.config.get('karmaMiles').POST_BOOST) || 100;
    this.remaining = this.karmaMile - this.boostCost;
    this.customTagCost = Math.abs(this.config.get('karmaMiles').CUSTOM_TAG);
    this.Math = Math;
  }

  ngOnChanges() {
    this.hidePost = false;
    this.actionsRegistered = {};

    if (
      !_.includes(this.allowedPosts, _.get(this.post, 'postType')) &&
      _.get(this.post, 'source') !== 'THREAD'
    ) {
      this.hidePost = true;
      return;
    }

    if (this.checkHiddenContent && !this.user.userShouldSeeContent(this.post)) {
      this.hidePost = true;
      return;
    }

    if (_.get(this.post, 'postType') === 'JOB') {
      this.addJobPosterInformationToUser();
    }

    this.loadPost();
  }

  private addJobPosterInformationToUser() {
    _.set(this.post, 'user._id', _.get(this.post, 'jobInformation.poster._id'));
    _.set(
      this.post,
      'user.userImage',
      _.get(this.post, 'jobInformation.poster.companyLogoSquare') ||
        _.get(this.post, 'jobInformation.poster.companyLogo')
    );
    _.set(
      this.post,
      'user.firstName',
      _.get(this.post, 'jobInformation.poster.name')
    );
    this.log('job post: ', this.post);
  }

  private loadPost() {
    // Some other types of posts may need to load additional info
    // the idea here is our feed may not load 100% of necessary data to speed
    // up feed loads, and then when the post is actually shown it will
    // load more

    if (_.get(this.post, 'source') === 'THREAD') {
      return (this.postInfo = this.post);
    }

    if (_.get(this.post, 'postType') === 'AD_SPEC') {
      return this.makePostAdSpec();
    }

    if (_.get(this.post, 'postType') === 'CUSTOM_COMPONENT') {
      return (this.postInfo = this.post);
    }

    const loaders = _.map(_.get(this.post, 'link_references'), ref => {
      return this.crudApi.get(`/api/${ref.route}/${ref.id}`).then(res => {
        _.set(this.post, `link_data.${ref.title}`, _.get(res, 'data'));

        if (!_.get(res, 'data')) {
          this.hidePost = true;
        }
      });
    });

    this.postInfo = null;
    this.hidePost = false;

    return Promise.all(loaders)
      .then(() => {
        this.postInfo = this.post;

        if (_.size(loaders)) {
          this.log('loaded data', this.post);
        }
      })
      .catch(e => {
        this.hidePost = true;
      });
  }

  ngOnDestroy() {
    _.each(this.subs, s => {
      if (s instanceof Function) {
        s();
      } else if (s.unsubscribe) {
        s.unsubscribe();
      }
    });
  }

  private makePostAdSpec() {
    const external = _.get(this.post, 'options.external');

    if (external) {
      let rate = external.takeoverRate;
      if (rate && rate > Math.random()) {
        this.adTakeover = external;
        this.hidePost = false;
        return;
      }
    }

    this.crudApi
      .get(
        this.env.adNetworkURL + '/api/adDelivery/ad',
        _.merge(_.get(this.post, 'options'), {
          pixelId: window['_ctagid'] || '',
          advertisingId: window['_advertisingId'] || '',
          cacheBust: new Date().getTime() + Math.random(),
        })
      )
      .then(
        res => {
          // Store kevel user key for any ads that don't go through
          // adDelivery / ad
          try {
            if (res.metadata && res.metadata.userKey) {
              localStorage.setItem('CDLC|AZ|USER', res.metadata.userKey);
            }
          } catch (e) {
            console.warn('metadata error', e);
          }

          if (!res.data) {
            this.hidePost = true;
            return;
          }
          this.post = res.data;
          this.postInfo = this.post;
        },
        e => {
          this.hidePost = true;
        }
      )
      .then(() => {
        if (!this.postInfo && external) {
          this.adTakeover = external;
          this.hidePost = false;
        }
      });
  }

  onPostAction(action) {
    // don't awnt to count clicks twice
    if (this.actionsRegistered[action]) {
      return;
    }

    this.actionsRegistered[action] = true;

    const adId = _.get(this.post, 'adParent._id');

    // Only ads for now
    if (adId) {
      const e = {
        impression: 'impressions',
        'link-click': 'clicks',
        open: 'full-views',
        action: 'actions',
      }[action];
      if (e && adId) {
        this.tools.logAnalyticsEvent('trackCustom', 'ad-network-' + e, {
          clid: _.get(this.post, 'clid'),
          ad: adId,
        });
        // Log tiimeseries for ads is deprecated. Everything will run through
        // cpix this.tools.logTimeSeries('ads', adId, e);
      }
    }
  }

  showBoostOptions() {
    let sufficient = `
      <style>
        .pill {
          display: flex;
          justify-content: flex-start;
          width: 100%;
          margin: -10px 0 25px -10px;
        }
        .content {
          display: flex;
          align-items: center;
          gap: 8px;
        }
        .fa-user-circle {
          color: #2e5ff6;
        }
        .pillText {
          font-weight: 500;
          font-size: 13px;
          letter-spacing: 0.01em;
          color: #2E5FF6;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          padding: 2.5px 4px;
          gap: 10px;
          background: rgba(46, 95, 246, 0.05);
          border-radius: 4px;
        }
        .contentContainer {
          display: flex;
          flex-direction: column;
          gap: 8px;
          text-align: center;
          height: 65vh;
        }
        .header {
          font-weight: 600;
          font-size: 20px;
          text-align: center;
          color: #262626;
        }
        .flex {
          display: flex;
          flex-grow: 1;
        }
        .infoContainer {
          display: flex;
          justify-content: space-around;
          align-items: center;
          align-self: center;
        }
        .info {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 18px 12px;
          gap: 8px;
          font-weight: 500;
          font-size: 14px;
          background: linear-gradient(256.71deg, #2E5FF6 0%, #7551E4 99.25%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          color: transparent;
        }
        .title {
          display: flex;
          align-items: center;
          line-height: 1em;
          gap: 8px;
        }
        .karma {
          color: #989aa2;
          -webkit-text-fill-color: #989aa2;
          font-weight: 300;
          font-size: 14px;
        }
        .value {
          font-size: 23px;
        }
        .cost {
          color: #2E5FF6;
          font-weight: 500;
        }
        hr {
          background: #E1E1E1;
          width: 100%;
        }
      </style>
      <div class="pill">
        <div class="content">
          <i class="far fa-user-circle"></i>
          <span class="pillText">
            ${this.karmaMile} Karma Miles
          </span>
        </div>
      </div>
      <div class="contentContainer">
        <div class="header">Post with Boost?</div>
        <div class="description">
          You’ve chosen to boost this post, <span class="cost">${this.boostCost}</span> Karma Miles will be deducted from your total
        </div>
        <hr />
        <div class="infoContainer">
          <div class="info">
            <div class="title">
              <i class="far fa-rocket"></i>
              <span>
                Boost Post
              </span>
            </div>
            <div class="value">${this.boostCost}</div>
            <div class="karma">Karma Miles</div>
          </div>
          <div class="info">
            <div class="title">
              <div>
                Remaining Balance
              </div>
            </div>
            <div class="value">${this.remaining}</div>
            <div class="karma">Karma Miles</div>
          </div>
        </div>
        <div class="flex"></div>
      <div>
    `;

    let insufficient = `
      <style>
        .pill {
          display: flex;
          justify-content: flex-start;
          width: 100%;
          margin: -10px 0 25px -10px;
        }
        .content {
          display: flex;
          align-items: center;
          gap: 8px;
        }
        .fa-user-circle {
          color: #2e5ff6;
        }
        .pillText {
          font-weight: 500;
          font-size: 13px;
          letter-spacing: 0.01em;
          color: #2E5FF6;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          padding: 2.5px 4px;
          gap: 10px;
          background: rgba(46, 95, 246, 0.05);
          border-radius: 4px;
        }
        .contentContainer {
          display: flex;
          flex-direction: column;
          gap: 8px;
          text-align: center;
          height: 65vh;
        }
        .header {
          font-weight: 600;
          font-size: 20px;
          text-align: center;
          color: #262626;
        }
        .flex {
          display: flex;
          flex-grow: 1;
        }
        .infoContainer {
          display: flex;
          justify-content: space-around;
          align-items: center;
          align-self: center;
        }
        .info {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 18px 12px;
          gap: 8px;
          font-weight: 500;
          font-size: 14px;
          background: linear-gradient(256.71deg, #2E5FF6 0%, #7551E4 99.25%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          color: transparent;
        }
        .title {
          display: flex;
          align-items: center;
          line-height: 1em;
          gap: 8px;
        }
        .karma {
          color: #989aa2;
          -webkit-text-fill-color: #989aa2;
          font-weight: 300;
          font-size: 14px;
        }
        .value {
          font-size: 23px;
        }
        .cost {
          color: #2E5FF6;
          font-weight: 500;
        }
        .alert {
          color: #EA4335;
        }
        .bold {
          font-weight: 500;
        }
        hr {
          background: #E1E1E1;
          width: 100%;
        }
      </style>
      <div class="pill">
        <div class="content">
          <i class="far fa-user-circle"></i>
          <span class="pillText">
            ${this.karmaMile} Karma Miles
          </span>
        </div>
      </div>
      <div class="contentContainer">
        <div class="header">Oops! Not Enough Karma Miles</div>
        <div class="description">
          Looks like you don’t have enough karma miles yet to boost this post. Earn more and boost this post later
        </div>
        <hr />
        <div class="infoContainer">
          <div class="info">
            <div class="title">
              <svg width="14" height="18" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.64062 16.5469C0.421875 17.7188 -0.140625 20.7656 0 24C3.23438 24.1406 6.28125 23.5781 7.45312 22.3594C9.375 20.4844 9.46875 17.9531 7.78125 16.2188C6.04688 14.5312 3.51562 14.625 1.64062 16.5469ZM5.48438 20.4844C5.0625 20.8594 4.07812 21.0469 3 21C2.95312 19.9219 3.14062 18.9375 3.51562 18.5156C4.17188 17.9062 5.01562 17.8594 5.57812 18.4219C6.14062 18.9844 6.09375 19.8281 5.48438 20.4844ZM23.6719 0.9375C23.5781 0.65625 23.3438 0.421875 23.0625 0.328125C21.5625 0 20.3906 0 19.2188 0C14.3906 0 11.4844 2.625 9.32812 6H4.40625C3.65625 6 2.76562 6.5625 2.4375 7.26562L0.09375 11.9062C0.046875 12.0469 0 12.2344 0 12.375C0 13.0312 0.46875 13.5 1.125 13.5H6C8.48438 13.5 10.5 15.5625 10.5 18V22.875C10.5 23.5312 10.9688 24 11.625 24C11.7656 24 11.9531 23.9531 12.0938 23.9062L16.7344 21.6094C17.4375 21.2344 17.9531 20.3438 17.9531 19.5938V14.6719C21.375 12.5156 23.9531 9.60938 23.9531 4.78125C24 3.60938 24 2.4375 23.6719 0.9375ZM16.7812 12.7969C15.5625 13.5469 16.4062 13.125 12.0938 15.2344C11.4375 13.7344 10.2656 12.5625 8.76562 11.9062C10.875 7.59375 10.4531 8.4375 11.2031 7.21875C13.4062 3.75 15.7969 2.25 19.2188 2.25C20.0625 2.25 20.7656 2.25 21.6094 2.39062C21.75 3.23438 21.75 3.98438 21.7031 4.78125C21.7031 8.15625 20.25 10.5938 16.7812 12.7969ZM17.25 4.875C16.1719 4.92188 15.375 5.71875 15.375 6.75C15.375 7.82812 16.1719 8.625 17.25 8.625C18.2812 8.625 19.125 7.82812 19.125 6.75C19.125 5.71875 18.2812 4.92188 17.25 4.875Z" fill="url(#paint0_linear_5016_98716)"/>
                <defs>
                <linearGradient id="paint0_linear_5016_98716" x1="24" y1="-2.99999" x2="-4.64472" y2="2.41077" gradientUnits="userSpaceOnUse">
                <stop stop-color="#2E5FF6"/>
                <stop offset="0.99253" stop-color="#7551E4"/>
                </linearGradient>
                </defs>
              </svg>
              <span>
                Boost Post
              </span>
            </div>
            <div class="value">${this.boostCost}</div>
            <div class="karma">Karma Miles</div>
          </div>
        </div>
        <div class="alert">
          <span class="bold">${Math.abs(
            this.remaining
          )}</span> more Karma Miles needed to boost
        </div>
        <div class="flex"></div>
      <div>
    `;

    if (this.remaining >= 0) {
      CmKit.ActionSheet({
        props: {
          templates: {
            title: sufficient,
            button: button => {
              return `
                    <button class="cm-Button cm-Button--1 cm-Width-1-1"
                            cm-color="Primary / CDLLife Blue">
                    ${button.text}
                    </button>
                    `;
            },
            cancel: `
              <div style="text-align:center"
                    cm-font="Button / 14 Regular"
                    class="cm-Margin--bottom"
                    cm-color="Neutral / Manatee">
                Post without Boost
              </div>
            `,
          },
          buttons: [
            {
              text: 'Post with Boost',
              handler: () => {
                this.handleUpdateWithBoost();
              },
            },
          ],
        },
      });
    } else {
      CmKit.ActionSheet({
        props: {
          templates: {
            title: insufficient,
            cancel: `
              <button class="cm-Button cm-Button--1 cm-Width-1-1"
                      cm-color="Primary / CDLLife Blue">
              Close
              </button>
            `,
          },
        },
      });
    }
  }

  handleUpdateWithBoost() {
    let crudPost: any = {};
    let spendKarma = {
      category: 'POST_BOOST',
      price: this.boostCost,
    };
    crudPost.user = this.post.user;

    crudPost.spendKarma = spendKarma;
    this.crudApi
      .put(`/api/posts/${_.get(this.post, '_id')}`, crudPost)
      .then(() => {
        this.post.wasBoosted = true;
        this.isBoostable = false;
      })
      .catch(e => {
        this.log('error updating post', e);
        const toast = this.toastCtrl.create({
          message:
            'An error occurred while updating the post. Please check your internet connection and try again. If the issue continues, please contact us for help.',
          showCloseButton: true,
          closeButtonText: 'OK',
        });
        toast.present();
        return;
      });
  }

  private friendEngagementLoader() {
    const lastComment = new Date(
        localStorage.getItem('friendEngagementLoader|lastComment')
      ),
      lastLike = new Date(
        localStorage.getItem('friendEngagementLoader|lastLike')
      ),
      lastAnything = new Date(
        localStorage.getItem('friendEngagementLoader|lastAnything')
      ),
      engagers = _.shuffle(_.get(this, 'post.engagers'));

    if (!engagers || !engagers.length) {
      return Promise.resolve();
    }

    if (lastAnything > moment().subtract(10, 'minute').toDate()) {
      return Promise.resolve();
    }

    /*
    // for now, we are removing the 6-hour limitation and instead using the
    // 10 minute for either
    let sixHours = moment()
      .subtract(6, 'hours')
      .toDate();

    if (lastComment > sixHours && lastLike > sixHours) {
      return Promise.resolve();
    }
    */

    return this.user.myFriends().then(friends => {
      let f = <any>_.find(_.shuffle(engagers), d => {
          return friends[d && d.user];
        }),
        friend = f ? friends[f.user] : null;

      if (friend) {
        if (f.engagementType === 'LIKE') {
          localStorage.setItem(
            'friendEngagementLoader|lastLike',
            new Date().toISOString()
          );
          this.postEngagementMessage = `
          <b>${friend.firstName} ${friend.lastName}</b> liked this.
          `.trim();
        } else if (f.engagementType === 'COMMENT') {
          localStorage.setItem(
            'friendEngagementLoader|lastComment',
            new Date().toISOString()
          );
          this.postEngagementMessage = `
          <b>${friend.firstName} ${friend.lastName}</b> commented on this.
          `.trim();
        } else {
          return;
        }

        localStorage.setItem(
          'friendEngagementLoader|lastAnything',
          new Date().toISOString()
        );
      }
    });
  }

  closeTagPendingModal() {
    this.tagPending.hide();
  }

  openTagPendingModal() {
    this.tagPending.show();
  }

  closeTagRejectedModal() {
    this.tagRejected.hide();
    let crudPost: any = {};
    crudPost.states = {
      hasCustomTag: {
        status: 'rejected_acknowledged',
      },
    };
    this.post = _.set(
      this.post,
      'states.hasCustomTag.status',
      'rejected_acknowledged'
    );
    this.crudApi
      .put(`/api/posts/${_.get(this.post, '_id')}`, crudPost)
      .catch(e => {
        this.log('error updating post', e);
        const toast = this.toastCtrl.create({
          message:
            'An error occurred while updating the post. Please check your internet connection and try again. If the issue continues, please contact us for help.',
          showCloseButton: true,
          closeButtonText: 'OK',
        });
        toast.present();
        return;
      });
  }

  openTagRejectedModal() {
    this.tagRejected.show();
  }
}



// WEBPACK FOOTER //
// ./src/components/post-loader/post-loader.ts